// extracted by mini-css-extract-plugin
module.exports = {"inactive":"cursor-weapper_inactive__WFlhB"};